import React, { useEffect, useRef, useState } from "react";
import { Divider } from "@material-ui/core";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import {
  Button,
  ButtonGroup,
  FormControl,
  MenuItem,
  Select,
  Box,
  Tab,
  InputLabel,
  ListSubheader,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  GetUserId,
  getAttributes,
  getUserDetails,
  GetUserInfo,
} from "../../../_utilities/getUserInfo";
import * as _ser1 from "../../../_redux/_services/ApplicantsSlice";
import * as _serapplicant from "../../../_redux/_services/ApplicantsSlice";
import * as _sercloud from "../../../_redux/_services/CloudSourcingSlice";
import * as _ser from "../../../_redux/_services/JobPostingSlice";
import { customFieldsAsync } from "../../../_redux/_services/UserManagerSlice";
import GetJobId from "../../../_utilities/GetJobId";
import {
  formatDate,
  GetTimeZone,
  getWorkonDate,
} from "../../../_utilities/GetTimeZone";
import { decrypt } from "../../../_utilities/_encryptDecryptHelper";
import { defaultApplicantsData } from "../../../_utilities/defaultfieldsModel";
import {
  getCandidateInternalStatus,
  getCandidateStatusId,
  getCandidateStatusCustomValues,
} from "../../../_utilities/internalexternalhelper";
import AssociateCards from "../../../components/AssociateCards/AssociateCards";
import CkEditor from "../../../components/CkEditor/CkEditor";
import DynamicTable from "../../../components/DynamicTable/DynamicTable";
import GenerateTemplateNew from "../../../components/GenerateTemplate/GenerateTemplateNew";
import RightSideBar from "../../../components/Rightsidebar/RightSideBar";
import ApplicantsManualUploadPopup from "../../Applicants/ApplicantsTable/ApplicantsManualUploadPopup";
import { ApplicantsRenderData } from "../../Applicants/ApplicantsTable/ApplicantsRenderData";
import DuplicateApplicantsManualUploadPopup from "../../Applicants/ApplicantsTable/DuplicateApplicantsManualUploadPopup";
import Loader from "../../../components/Loader/Loader";
import { updateGlobalLoading } from "../../../_redux/LoaderSlice";
import "./PostingsAssociatedApplicantsProfile.css";
import { updateSnackbar } from "../../../_redux/SnackbarSlice";
import { UpdateStausillus } from "../../../Icons/UpdateStausillus";
import { Notescall } from "../../../Icons/Notescall";
import { Notesemail } from "../../../Icons/Notesemail";
import { FloatButon } from "../../../Icons/FloatButon";
// import { DocumentViewer } from 'react-documents';
import DocumentViewer from "../../../components/DocumentViewer/DocumentViewer";
import { ViewFileIcon } from "../../../Icons/ViewFileIcon";
import { DownloadIcon } from "../../../Icons/DownloadIcon";
import { DashboardPlusicon } from "../../../Icons/DashboardPlusicon";
import * as _userSer from "../../../_redux/_services/UserManagerSlice";
import ClientMail from "./ClientMail";
import axios from "axios";
import { getFileExtension } from "../../../_utilities/utilities";
import EmailDeliverySummary from "../../../components/EmailDeliverySummary";

const initalState = { data: null, message: "", isloader: true };

const JobpostingsAssociatedApplicantsProfile = () => {
  const [showTable, setShowTable] = useState(false);
  const [AccociatedApplicants, setAccociatedApplicants] = useState([]);
  const [isRightSidePannel, setIsRightSidePannel] = useState(false);
  const [componentType, setComponentType] = useState("AssociatedApplicants");
  const [questionsData, setQuestionsData] = useState([]);
  const [showApplicantDetails, setShowApplicantDetails] = useState(false);
  const [qnsCount, setQnsCount] = useState(0);
  const [candidateStatusValues, setCandidateStatusValues] = useState([]);
  const [portalAccociatedApplicants, setPortalAccociatedApplicants] = useState(
    [],
  );
  const [config, setConfig] = useState(configuration);
  const [moduleType, setModuleType] = useState("Associated Applicants");
  const [rejectedApplicants, setRejectedApplicants] = useState([]);
  const [profileData, setProfileData] = useState("");
  const [applicantTemp, setApplicantTemp] = useState("");
  const [applicantCodes, setApplicantCodes] = useState([]);
  const [docUrl, setDocUrl] = useState("");
  const [pannelobj, setPannelobj] = useState({
    title: "",
    description: "",
    bgImage: "",
    navigateTo: "",
  });
  const [isGenerateTemplate, setIsGenerateTemplate] = useState(false);
  const [jobCode, setJobCode] = useState(null);
  const [bulkUploadMessage, setBulkUploadMessage] = useState({});
  const [isBulkuploadResponse, setIsBulkuploadResponse] = useState(false);
  const [isBulkUpdateStatus, setIsBulkUpdateStatus] = useState(false);
  const [bulkUpdateStatusArray, setbulkUpdateStatusArray] = useState([]);
  const [isValidUser, setIsValidUser] = useState(false);
  const [isDocumentView, setIsDocumentView] = useState(false);
  const [previewType, setPreviewType] = useState("");
  const [actionType, setActionType] = useState("");
  const [selectedApplicants, setSelectedApplicants] = useState([]);
  const [selectedDoc, setSelectedDoc] = useState({});

  const [applicantDocumentsDetails, setApplicantDocumentsDetails] = useState(
    [],
  );
  const responseOfQuestionAnswer = useSelector(
    (state) => state.GetQuestionsAnswers.data,
  );
  const nextPathValue = useSelector((state) => state.SeletedNextPath.value);
  const bulkUploadResumeData = useSelector(
    (store) => store.BulkUploadResume.data,
  );
  const customFieldsData = useSelector((state) => state.CustomFields.data);
  const sendEmail = useSelector((state) => state.SendEmail.data);
  const ClientBulkEmail = useSelector((state) => state.ClientBulkEmail.data);

  useEffect(() => {
    if (bulkUploadResumeData) {
      setIsBulkuploadResponse(true);
      setBulkUploadMessage(bulkUploadResumeData);
      dispatch(_ser1.bulkUploadResumeStartReducer(initalState));
    }
  }, [bulkUploadResumeData]);

  useEffect(() => {
    async function init() {
      let userId = await GetUserId();
      dispatch(customFieldsAsync(userId));
    }
    init();
  }, []);

  useEffect(() => {
    if (customFieldsData && customFieldsData.length > 0) {
      const array = getCandidateStatusCustomValues(customFieldsData);
      setCandidateStatusValues(array);
    }
  }, [customFieldsData]);

  const dispatch = useDispatch();
  const getJobCode = GetJobId();

  useEffect(() => {
    if (getJobCode !== null) {
      FetchData();
    }
  }, [getJobCode]);

  useEffect(() => {
    if (nextPathValue === "null") {
      setShowApplicantDetails(false);
      localStorage.setItem("AssociatedMenu", "false");
      window.dispatchEvent(new Event("storage"));
    }
  }, [nextPathValue]);

  const AccociatedApplicantsData = useSelector(
    (state) => state.GetAssociatedApplicants.data,
  );
  const AccociatedApplicantsDataCode = useSelector(
    (state) => state.GetAssociatedApplicants.code,
  );
  const AssociatedApplicantById = useSelector(
    (state) => state.GetAssociatedApplicantById.data,
  );

  useEffect(() => {
    if (AccociatedApplicantsDataCode === 404) {
      setIsValidUser(true);
    }
  }, [AccociatedApplicantsDataCode]);

  const FetchData = async () => {
    setAccociatedApplicants([]);
    setPortalAccociatedApplicants([]);
    setRejectedApplicants([]);
    dispatch(_ser.getAssociatedApplicantsAsync(getJobCode));
  };

  useEffect(() => {
    if (
      AccociatedApplicantsData !== null &&
      AccociatedApplicantsData !== undefined
    ) {
      if (AccociatedApplicantsData.length > 0) {
        const myData = JSON.parse(JSON.stringify(AccociatedApplicantsData));
        setQnsCount(myData[0].qnscount);
        let newArray = [];
        let newPortalArray = [];
        let newRejectedArray = [];
        if (myData !== undefined) {
          myData.forEach((e) => {
            e["isChecked"] = false;
            e["id"] = e.applicantID;
            e["percentage"] =
              e.matchPercentage !== -1
                ? Math.round(e.matchPercentage * 100)
                : "N/A";
            e.updatedDate = GetTimeZone(e.updatedDate);
            e.firstName = e.firstName ? e.firstName : " ";
            e.lastName = e.lastName ? e.lastName : " ";
            e["createdBy"] = e.firstName + " " + e.lastName;
            if (candidateStatusValues.length) {
              e.status = getCandidateInternalStatus(
                e.status,
                candidateStatusValues,
              );
            }
            if (e.status === "Pending" || e.status === "pending") {
              // TO BE UPDATED
              e["screeningquestions"] = `${e.anscount}/${myData[0].qnscount}`;
              newPortalArray.push(e);
              setPortalAccociatedApplicants(newPortalArray);
            } else if (e.status === "Rejected") {
              // TO BE UPDATED
              e["screeningquestions"] = `${e.anscount}/${myData[0].qnscount}`;
              newRejectedArray.push(e);
              setRejectedApplicants(newRejectedArray);
            } else {
              e["screeningquestions"] = "";
              newArray.push(e);
              setAccociatedApplicants(newArray);
            }
          });
          let configure = JSON.parse(JSON.stringify(config));
          let records =
            moduleType === "Pending Applicants"
              ? newPortalArray.length
              : moduleType === "Rejected Applicants"
                ? newRejectedArray.length
                : newArray.length;
          configure.totalRecords = records;
          configure.currentPage = 1;
          setConfig(configure);
          setComponentType("AssociatedApplicants");
          setShowTable(true);
        }
        dispatch(_ser.getAssociatedApplicantsStartReducer(initalState));
      } else {
        setAccociatedApplicants([]);
        setPortalAccociatedApplicants([]);
        setRejectedApplicants([]);
      }
    }
  }, [AccociatedApplicantsData, candidateStatusValues]);

  useEffect(() => {
    if (moduleType === "Pending Applicants") {
      let configure = JSON.parse(JSON.stringify(config));
      configure.totalRecords = portalAccociatedApplicants.length;
      configure.currentPage = 1;
      configure.isDropdownActions = true;
      configure.isCheckbox = true;
      setConfig(configure);
      portalAccociatedApplicants.forEach((item) => {
        item.isChecked = false;
      });
      setPortalAccociatedApplicants(portalAccociatedApplicants);
    } else if (moduleType === "Rejected Applicants") {
      let configure = JSON.parse(JSON.stringify(config));
      configure.totalRecords = rejectedApplicants.length;
      configure.currentPage = 1;
      configure.isDropdownActions = false;
      configure.isCheckbox = false;
      setConfig(configure);
      rejectedApplicants.forEach((item) => {
        item.isChecked = false;
      });
      setRejectedApplicants(rejectedApplicants);
    } else if (moduleType === "Associated Applicants") {
      let configure = JSON.parse(JSON.stringify(config));
      configure.totalRecords = AccociatedApplicants.length;
      configure.currentPage = 1;
      configure.isDropdownActions = true;
      configure.isCheckbox = true;
      setConfig(configure);
      AccociatedApplicants.forEach((item) => {
        item.isChecked = false;
      });
      setAccociatedApplicants(AccociatedApplicants);
    }
  }, [moduleType]);

  useEffect(() => {
    if (
      AssociatedApplicantById !== null &&
      AssociatedApplicantById !== undefined
    ) {
      setIsRightSidePannel(true);
      setComponentType("ApplicantProfile");
      setProfileData(AssociatedApplicantById);
      setPannelobj({
        ...pannelobj,
        title: `${AssociatedApplicantById.applicantName} (${AssociatedApplicantById.applicantCode})`,
        navigateTo: `/ats/layout/applicants/view/${AssociatedApplicantById.applicantId}`,
      });
      dispatch(_ser.getAssociatedApplicantByIdStartReducer(initalState));
    }
  }, [AssociatedApplicantById]);

  useEffect(() => {
    if (sendEmail === 200 || ClientBulkEmail === 200) {
      let Data = [...AccociatedApplicants];
      Data.forEach((item) => {
        item.isChecked = false;
      });
      setAccociatedApplicants(Data);
      setConfig({ ...config });
      dispatch(_userSer.SendEmailStartReducer(initalState));
      dispatch(_userSer.ClientBulkEmailStartReducer(initalState));
    }
  }, [sendEmail, ClientBulkEmail]);

  // for dynamic component received props
  const onReceiveActionHandler = async (type, object) => {
    if (type === "detailspage") {
      dispatch(_ser.getAssociatedApplicantByIdAsync(object.asscoId));
    } else if (type === "confirmDel") {
      DeleteAssociatedJobseeker(object);
    } else if (type === "viewAnswers") {
      let Obj = {
        cs_id: object.cs_id ? object.cs_id : 0,
        job_id: getJobCode,
        applicant_id: object.applicantID, //TODO
      };
      dispatch(_sercloud.getQuestionsAnswersReducerAsync(Obj));
    } else if (type === "Accept" || type === "Reject") {
      const url = window.location.pathname;
      const path = url.substring(url.lastIndexOf("/") + 1);
      let jobCode = "";
      if (Number.isInteger(parseInt(path))) {
        let subpathObj = JSON.parse(localStorage.getItem("subpathObj"));
        if (subpathObj && subpathObj.length > 0) {
          let filterSubObj = subpathObj.filter(
            (x) => x.id === parseInt(path) && x.type === "Job Code",
          );
          if (filterSubObj.length > 0) {
            jobCode = filterSubObj[0].name;
          }
        }
      }
      let matches = jobCode.match(/\(([^)]+)\)/g);
      let splitJobcode = matches[matches.length - 1].replace(/[()]/g, "");
      let newArray = object.map((obj) => ({
        id: obj.asscoId,
        status: type === "Accept" ? "Associated" : "Rejected",
        applicantCode: obj.applicantCode,
        applicantId: obj.applicantID.toString(),
        jobCode: splitJobcode,
      }));
      let updateData = { data: newArray };
      dispatch(_ser.updateCandidateStatusAsync(getJobCode, updateData));
    } else if (type === "Download" || type === "download") {
      setProfileData(object);
      DownloadFileFromS3(object, type);
    } else if (type === "view") {
      setProfileData(object);
      DownloadFileFromS3(object, type);
      setIsDocumentView(true);
    } else if (type === "Send E-mail") {
      setIsGenerateTemplate(true);
      // let object = selectedApplicants;
      setSelectedApplicants(object);
      const url = window.location.pathname;
      const path = url.substring(url.lastIndexOf("/") + 1);
      if (Number.isInteger(parseInt(path))) {
        let subpathObj = JSON.parse(localStorage.getItem("subpathObj"));
        if (subpathObj && subpathObj.length > 0) {
          let filterSubObj = subpathObj.filter(
            (x) => x.id === parseInt(path) && x.type === "Job Code",
          );
          if (filterSubObj.length > 0) {
            setJobCode(filterSubObj[0].name);
            setApplicantCodes(object);
            // dispatch(_ser1.applicantsByIdAsync(object[0].applicantID));
            setApplicantDocumentsDetails(
              object.map((item) => {
                return {
                  docid: item.docsid,
                  docName: item.docName,
                  docfileType: item.docfileType,
                  updatedDate: GetTimeZone(item.updatedDate),
                  uploadedBy: item.submittedByUser,
                };
              }),
            );
          }
        }
      }
    } else if (type === "Update Status") {
      setIsBulkUpdateStatus(true);
      setbulkUpdateStatusArray(object);
    } else if (type === "cancelSearchResult") {
      FetchData();
    } else if (type === "pageRange") {
      setConfig({
        ...config,
        limitData: (config.limitData = object),
        recordperPage: (config.limitData = object),
        currentPage: 1,
      });
    }
  };

  // const ApplicantData = useSelector((state) => state.ApplicantsById.data);

  // useEffect(() => {
  //   if (ApplicantData) {
  //     let applicantData = { ...ApplicantData[0] };
  //     let workExpObj = JSON.parse(applicantData.workExp) || [];
  //     let designation =
  //       workExpObj?.length > 0
  //         ? `${workExpObj[0]?.jobTitle || workExpObj[0]?.title || ''}${workExpObj[0]?.organization ? ' / ' + workExpObj[0]?.organization : ''}`
  //         : '';
  //     applicantData.educationDetails = JSON.parse(
  //       applicantData.educationDetails
  //     );
  //     applicantData.workExp = workExpObj;
  //     let expObject = workExpObj[0]?.experienceInMonths
  //       ? workExpObj[0]?.experienceInMonths
  //       : {
  //           startDate: workExpObj[0]?.startDate,
  //           endDate: Boolean(workExpObj[0]?.isCurrent)
  //             ? 'present'
  //             : workExpObj[0]?.endDate,
  //         };
  //     applicantData['currentWorking'] = {
  //       designation: designation,
  //       from: getWorkonDate(expObject, 'level2'),
  //     };
  //     setApplicantTemp(applicantData);
  //   }
  // }, [ApplicantData]);

  const updateCandidateCode = useSelector(
    (state) => state.UpdateCandidateStatus.data,
  );
  useEffect(() => {
    if (updateCandidateCode === 200) {
      dispatch(_ser.updateCandidateStatusStartReducer(initalState));
      FetchData();
    }
  }, [updateCandidateCode]);

  useEffect(() => {
    if (responseOfQuestionAnswer && responseOfQuestionAnswer.length > 0) {
      let newObj = JSON.parse(JSON.stringify(responseOfQuestionAnswer));
      newObj.forEach((item) => {
        item.answer = JSON.parse(item.answer);
      });
      setQuestionsData(newObj);
      setIsRightSidePannel(true);
      setComponentType("Questions&Answers");
      dispatch(_sercloud.getQuestionsAnswersStartReducer({}));
    }
  }, [responseOfQuestionAnswer]);

  const DeleteAssociatedJobseekercode = useSelector(
    (state) => state.DeleteAssociatedJobseeker.data,
  );

  const DeleteAssociatedJobseeker = async (object) => {
    if (object.SourcedFrom === "Cloudsourcing") {
      object["portalassociatedApplicants"] = "csassociatedApplicants";
    } else if (object.SourcedFrom === "Employee Portal") {
      object["portalassociatedApplicants"] = "eassociatedApplicants";
    } else if (object.SourcedFrom === "Vendorsourcing") {
      object["portalassociatedApplicants"] = "vsassociatedApplicants";
    } else {
      object["portalassociatedApplicants"] = "associatedApplicants";
    }
    let array = object.map((i) => i.asscoId);
    let deleteIds = { ids: array };
    dispatch(
      _ser.deleteAssociatedJobseekerAsync(
        getJobCode,
        object[0].applicantID,
        deleteIds,
      ),
    );
  };

  useEffect(() => {
    if (DeleteAssociatedJobseekercode === 200) {
      setShowTable(false);
      FetchData();
      dispatch(_ser.deleteAssociatedJobseekerStartReducer(initalState));
    }
  }, [DeleteAssociatedJobseekercode]);

  const onReceivePropsHandler = (pannel, load) => {
    if (load == "getFetch") {
      setIsRightSidePannel(pannel);
      FetchData();
    } else if (load === "close") {
      setIsBulkuploadResponse(pannel);
      setIsRightSidePannel(pannel);
      setIsBulkUpdateStatus(pannel);
      setComponentType("AssociatedApplicants");
      setIsGenerateTemplate(pannel);
      setIsDocumentView(pannel);
      // setApplicantCodes([]);
      if (componentType === "ApplicantProfile") {
        FetchData();
      }
    } else if (load === "download") {
      DownloadFileFromS3(pannel, load);
    } else if (load === "view") {
      setIsRightSidePannel(false);
      setIsDocumentView(true);
      DownloadFileFromS3(pannel, load);
    } else if (
      load === "Please select client to send an email to hiring manager"
    ) {
      setApplicantCodes([]);
      let Data = [...AccociatedApplicants];
      Data.forEach((item) => {
        item.isChecked = false;
      });
      setAccociatedApplicants(Data);
      setTimeout(() => {
        dispatch(_ser.listjobpostingsStartReducer(initalState));
        dispatch(updateSnackbar({ type: "error", message: load }));
      }, 500);
    }
  };

  const onChangeModule = (type) => {
    if (type == "Associated Applicants") {
      setModuleType("Associated Applicants");
    } else if (type == "Pending Applicants") {
      setModuleType("Pending Applicants");
    } else if (type == "Rejected Applicants") {
      setModuleType("Rejected Applicants");
    }
  };

  const docData = useSelector((state) => state.Downloaddocument.data);

  const DownloadFileFromS3 = async (object, type) => {
    type = type === "view" ? "preview" : "download";
    setSelectedDoc(object);
    let Url = object.filePath;
    setDocUrl(Url);
    dispatch(
      _serapplicant.downloaddocumentAsync(
        object.applicantId,
        type,
        object.documentId,
      ),
    );
    setActionType(type);
  };

  // useEffect(() => {
  //   if (docData) {
  //     if (actionType === 'Download' || actionType === 'download') {
  //       const link = document.createElement('a');
  //       link.href = docData;
  //       link.download = docUrl;
  //       document.body.appendChild(link);
  //       link.click();
  //       document.body.removeChild(link);
  //     } else {
  //       setPreviewType(docData);
  //     }
  //     dispatch(_serapplicant.downloaddocumentStartReducer(initalState));
  //   }
  // }, [docData]);

  const guessNameFromUrl = (url) => {
    try {
      return decodeURIComponent(
        new URL(url).pathname.split("/").pop() || "download",
      );
    } catch {
      return "download";
    }
  };

  useEffect(() => {
    if (!docData) return;

    const run = async () => {
      try {
        if ((actionType || "").toLowerCase() === "download") {
          if (typeof docData === "string") {
            const filename =
              selectedDoc?.fileName ||
              selectedDoc.fileName ||
              guessNameFromUrl(docData);
            // force download via Blob
            const res = await fetch(docData, {
              cache: "no-store",
              credentials: "omit",
            });
            const blob = await res.blob();
            const href = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = href;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(href);
          } else {
            const url = selectedDoc?.filePath ?? "";
            const extention = url?.substring(url?.lastIndexOf(".") + 1);

            const filename =
              selectedDoc?.fileName ||
              selectedDoc.fileName ||
              `document.${(extention || "pdf").toLowerCase()}`;
            const blob =
              docData instanceof Blob ? docData : new Blob([docData]);
            const href = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = href;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(href);
          }
        } else {
          setPreviewType(docData);
        }
      } finally {
        dispatch(_serapplicant.downloaddocumentStartReducer(initalState));
      }
    };

    run();
  }, [docData]);

  const storedTheme = JSON.parse(localStorage.getItem("themeSettings")) || "";

  return (
    <>
      {!showApplicantDetails &&
      moduleType === "Associated Applicants" &&
      !isValidUser ? (
        <div
          className="adddocumentsection"
          style={{ display: "flex", height: "34px", gap: "10px" }}
          onClick={() => setIsRightSidePannel(true)}
        >
          <DashboardPlusicon width={35} height={36} />
          <h4 className="addnewdocumenttext">Associate Applicants</h4>
        </div>
      ) : (
        ""
      )}
      {showApplicantDetails ? (
        <div id="InnerComponents"></div>
      ) : (
        <div className="contentSection">
          <div className="drop_down">
            <div className="groupButtons">
              <ButtonGroup variant="contained">
                <Button
                  className={
                    moduleType === "Associated Applicants" ? "active" : ""
                  }
                  onClick={() => onChangeModule("Associated Applicants")}
                >
                  Associated Applicants ({AccociatedApplicants.length})
                </Button>
                <Button
                  className={
                    moduleType === "Pending Applicants" ? "active" : ""
                  }
                  onClick={() => onChangeModule("Pending Applicants")}
                >
                  Pending Applicants ({portalAccociatedApplicants.length})
                </Button>
                <Button
                  className={
                    moduleType === "Rejected Applicants" ? "active" : ""
                  }
                  onClick={() => onChangeModule("Rejected Applicants")}
                >
                  Rejected Applicants ({rejectedApplicants.length})
                </Button>
              </ButtonGroup>
            </div>
          </div>
          {moduleType === "Associated Applicants" ? (
            <>
              {AccociatedApplicants.length > 0 && (
                <DynamicTable
                  config={config}
                  data={AccociatedApplicants}
                  colmns={columnsData}
                  actionDropdown={actionsDropdownData}
                  actions={actionsList}
                  addModel={addNewModel}
                  searchKeyWord="Search by ID, Name, Contact Number"
                  noDataText="No associated applicants"
                  onReceiveActionProps={(type, obj) =>
                    onReceiveActionHandler(type, obj)
                  }
                />
              )}
              {AccociatedApplicants.length === 0 && (
                <DynamicTable
                  config={configuration}
                  data={AccociatedApplicants}
                  colmns={columnsData}
                  actionDropdown={actionsDropdownData}
                  actions={actionsList}
                  addModel={addNewModel}
                  searchKeyWord="Search by ID, Name, Contact Number"
                  noDataText="No associated applicants"
                  onReceiveActionProps={(type, obj) =>
                    onReceiveActionHandler(type, obj)
                  }
                />
              )}
            </>
          ) : moduleType === "Pending Applicants" ? (
            <>
              {portalAccociatedApplicants.length > 0 && (
                <DynamicTable
                  config={config}
                  data={portalAccociatedApplicants}
                  colmns={portalsColumnsData}
                  actionDropdown={actionsDropdownDataPending}
                  actions={actionsList}
                  addModel={addNewModel}
                  searchKeyWord="Search by ID, Name, Contact Number"
                  noDataText="No pending applicants"
                  onReceiveActionProps={(type, obj) =>
                    onReceiveActionHandler(type, obj)
                  }
                />
              )}
              {portalAccociatedApplicants.length === 0 && (
                <DynamicTable
                  config={config}
                  data={portalAccociatedApplicants}
                  colmns={portalsColumnsData}
                  actionDropdown={actionsDropdownDataPending}
                  actions={actionsList}
                  addModel={addNewModel}
                  searchKeyWord="Search by ID, Name, Contact Number"
                  noDataText="No pending applicants"
                  onReceiveActionProps={(type, obj) =>
                    onReceiveActionHandler(type, obj)
                  }
                />
              )}
            </>
          ) : moduleType === "Rejected Applicants" ? (
            <>
              {rejectedApplicants.length > 0 && (
                <DynamicTable
                  config={config}
                  data={rejectedApplicants}
                  colmns={rejectColumnsData}
                  actionDropdown={actionsDropdownDataPending}
                  actions={actionsList}
                  addModel={addNewModel}
                  searchKeyWord="Search by ID, Name, Contact Number"
                  noDataText="No rejected applicants"
                  onReceiveActionProps={(type, obj) =>
                    onReceiveActionHandler(type, obj)
                  }
                />
              )}
              {rejectedApplicants.length === 0 && (
                <DynamicTable
                  config={config}
                  data={rejectedApplicants}
                  colmns={rejectColumnsData}
                  actionDropdown={actionsDropdownDataPending}
                  actions={actionsList}
                  addModel={addNewModel}
                  searchKeyWord="Search by ID, Name, Contact Number"
                  noDataText="No rejected applicants"
                  onReceiveActionProps={(type, obj) =>
                    onReceiveActionHandler(type, obj)
                  }
                />
              )}
            </>
          ) : (
            " "
          )}
        </div>
      )}
      <div
        className={
          componentType === "Questions&Answers"
            ? "rightsidebarbtn_question"
            : "rightsidebarbtn"
        }
      >
        {isRightSidePannel && getJobCode ? (
          <RightSideBar
            componentData={
              <ComponentRenderData
                JobId={getJobCode}
                dispatch={dispatch}
                isLoad={isRightSidePannel}
                clientData={AccociatedApplicants}
                componentType={componentType}
                onReceivechildProps={onReceivePropsHandler}
                questionsData={questionsData}
                profileData={profileData}
              />
            }
            componentLayout={
              componentType === "AssociatedApplicants"
                ? ASAObj
                : componentType === "Questions&Answers"
                  ? QAObj
                  : componentType === "ApplicantProfile"
                    ? pannelobj
                    : ""
            }
            footerImg={
              componentType === "AssociatedApplicants" ? (
                <UpdateStausillus />
              ) : componentType === "Questions&Answers" ? (
                questionsData?.length >= 2 ? (
                  ""
                ) : (
                  <UpdateStausillus />
                )
              ) : componentType === "ApplicantProfile" ? (
                <UpdateStausillus />
              ) : (
                ""
              )
            }
            isFooter={
              !(
                componentType === "Questions&Answers" &&
                questionsData?.length >= 2
              )
            }
            onReceiveProps={onReceivePropsHandler}
          />
        ) : (
          ""
        )}
      </div>
      {Boolean(isGenerateTemplate) && (
        <RightSideBar
          componentData={
            <GenerateTemplateNew
              isAssociatedProfile={true}
              applicantDetails={profileData}
              tempApplicant={applicantTemp}
              applicantCodes={applicantCodes}
              jobCode={jobCode}
              documents={applicantDocumentsDetails}
              onReceiveProps={onReceivePropsHandler}
            />
          }
          componentLayout={MailOBJ}
          onReceiveProps={onReceivePropsHandler}
        />
      )}

      {Boolean(isBulkuploadResponse) && (
        <div id="bulkUploadResults">
          <RightSideBar
            componentData={
              <BulkComponentRenderData
                data={bulkUploadMessage}
                onReceivechildProps={onReceivePropsHandler}
              />
            }
            componentLayout={bulkResponseObj}
            onReceiveProps={onReceivePropsHandler}
          />
        </div>
      )}
      {Boolean(isBulkUpdateStatus) && (
        <div id="bulkUploadStatus">
          <RightSideBar
            componentData={
              <BulkUpdateStatus
                data={candidateStatusValues}
                bulkUpdateStatusArray={bulkUpdateStatusArray}
                onReceivechildProps={onReceivePropsHandler}
              />
            }
            componentLayout={UpdateStatusObj}
            onReceiveProps={onReceivePropsHandler}
          />
        </div>
      )}
      {Boolean(isDocumentView) && (
        <div
          id="documentView"
          className={`jobDocument-${getFileExtension(previewType)}`}
        >
          <RightSideBar
            className="associationProfileDocView"
            componentData={
              <ViewDocument
                data={profileData}
                previewType={previewType}
                onReceivechildProps={onReceivePropsHandler}
              />
            }
            componentLayout={docViewObj}
            onReceiveProps={onReceivePropsHandler}
          />
        </div>
      )}
      <EmailDeliverySummary candidateMailId={applicantCodes[0]?.emailId}/>
    </>
  );
};
const ComponentRenderData = React.memo(
  ({
    dispatch,
    JobId,
    clientData,
    onReceivechildProps,
    componentType,
    isLoad,
    questionsData,
    profileData,
  }) => {
    const [jobData, setjobData] = useState(null);
    const [AlljobData, setAlljobData] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]); //  clientData.map(x => x.applicantID)
    const [findconfig, setFindconfig] = useState(findconfiguration);
    const [aiconfig, setaiconfig] = useState(aiconfiguration);
    const [searchValue, setSearchValue] = useState("");
    const [value, setValue] = React.useState("3");
    const [totalRecords, setTotalRecords] = useState(null);
    const SearchAffinda = useSelector((state) => state.SearchAffinda.data);
    const showLoader = useSelector((state) => state.Loader);
    const navigate = useNavigate();
    const [manualApplicatsConfirmPopup, setManualApplicatsConfirmPopup] =
      useState(false);
    const [updateProfileWithNewResume, setUpdateProfileWithNewResume] =
      useState(null);
    const [sourceId, setSourceId] = useState(0);
    const [defaultFile, setDefaultFile] = useState(null);
    const [keyword, setKeyword] = useState("");
    const [duplicateApplicatsConfirmPopup, setDuplicateApplicatsConfirmPopup] =
      useState(false);
    const [
      twoDuplicateApplicatsConfirmPopup,
      setTwoDuplicateApplicatsConfirmPopup,
    ] = useState(false);
    const UploadDocCode = useSelector((state) => state.UploadDocuments.data);
    const [skipId, setSkipId] = useState(null);
    const [skipName, setSkipName] = useState(null);

    const [profileValue, setProfileValue] = useState("1");
    const [user, setUser] = useState([]);
    const [candidateStatusValues, setCandidateStatusValues] = useState([]);
    const [AuditlogData, setAuditlogData] = useState([]);
    const [profileUpdate, setProfileUpdate] = useState("");
    const [updateStatus, setUpdateStatus] = useState("");
    const [noteType, setNoteType] = useState("Call");
    const [jobObj, setJobObj] = useState({});

    const getJobCode = GetJobId();
    const cancelRef = useRef(null);

    useEffect(() => {
      if (clientData.length > 0) {
        let selectedIdsArray = [];
        clientData.map((x) => {
          let obj = {
            id: x.applicantID,
            // documentName : x.docsname,
            // lastUpdated : x.docscreatedDate,
            // uploadedBy: x.docUploadedBy,
            docId: x.docsid,
          };
          selectedIdsArray.push(obj);
        });
        setSelectedIds(selectedIdsArray);
      }
    }, [clientData, AlljobData, jobData]);

    const GetData = async (obj) => {
      let jobIdentifier = localStorage.getItem("JobIdentifier");
      if (jobIdentifier !== "null") {
        dispatch(updateGlobalLoading(false));
        dispatch(_ser.searchAffindaAsync(obj, jobIdentifier));
        setaiconfig({ ...aiconfig, currentPage: obj.currentPage || 1 });
      }
    };

    useEffect(() => {
      if (SearchAffinda !== null && SearchAffinda !== undefined) {
        setjobData(null);
        if (SearchAffinda.length > 0) {
          const myData = [];
          let applicantsData = JSON.parse(JSON.stringify(SearchAffinda));
          applicantsData.forEach((e) => {
            if (e.length > 0) {
              myData.push(...e);
            } else if (typeof e === "object" && e.id) {
              myData.push(e);
            }
          });

          setjobData(myData);
          dispatch(_ser.searchAffindaStartReducer(initalState));
        } else {
          setjobData([]);
        }
      }
    }, [SearchAffinda]);

    const onActionHandler = (id, type) => {
      if (type === "delete") {
        DeleteAssociatedjobs(id);
      } else if (type === "add") {
        AddAssociatedjobs(id);
      } else if (
        type === "searchResult" &&
        parseInt(value) === 2 &&
        id.keyword !== ""
      ) {
        setSearchValue(id.keyword ? id.keyword : id);
        getListApplicants(id);
      }
    };

    const DelAssociatedJobcode = useSelector(
      (state) => state.DeleteAssociatedJob.data,
    );

    const DeleteAssociatedjobs = async (obj) => {
      let data = {};
      dispatch(_ser.deleteAssociatedJobAsync(JobId, obj, data));
    };

    useEffect(() => {
      if (DelAssociatedJobcode === 200) {
        onReceivechildProps(true, "getFetch");
        dispatch(_ser.deleteAssociatedStartReducer(initalState));
      }
    }, [DelAssociatedJobcode]);

    const AddAssociatedjobsCode = useSelector(
      (state) => state.AddAssociatedjobs.data,
    );

    const AddAssociatedjobs = async (obj) => {
      let userInfo = await GetUserInfo();
      let userId = await getAttributes();
      obj["source"] = obj.source; // "ATS"
      obj["submittedBy"] = userInfo[0].id;
      obj["firstName"] = userId[0].firstName;
      obj["lastName"] = userId[0].lastName;
      obj["status"] = "Associated";
      dispatch(_ser.addAssociatedjobsAsync(JobId, obj, "applicant"));
    };

    useEffect(() => {
      if (AddAssociatedjobsCode === 200) {
        dispatch(_ser.addAssociatedjobsStartReducer(initalState));
        onReceivechildProps(true, "getFetch");
      }
    }, [AddAssociatedjobsCode]);

    useEffect(() => {
      if (isLoad === true) {
        const url = window.location.pathname;
        const path = url.substring(url.lastIndexOf("/") + 1);
        if (Number.isInteger(parseInt(path))) {
          let subpathObj = JSON.parse(localStorage.getItem("subpathObj"));
          let filterSubObj = subpathObj.filter(
            (x) => x.id === parseInt(path) && x.type === "Job Code",
          );
          if (filterSubObj.length > 0) {
            let jobIdentifier = localStorage.getItem("JobIdentifier");
            setKeyword(jobIdentifier);
          }
        }
      }
    }, [JobId, isLoad]);

    const GetListApplicants = useSelector(
      (state) => state.SearchApplicantsWithPaging.data,
    );

    const getListApplicants = (obj) => {
      dispatch(updateGlobalLoading(false));
      if (cancelRef.current) cancelRef.current();
      const source = axios.CancelToken.source();
      cancelRef.current = source.cancel;
      let fields = "docs";
      let url = undefined;
      dispatch(
        _serapplicant.searchApplicantsWithPagingAsync(
          obj.limit,
          obj.offset,
          obj.keyword,
          url,
          fields,
          source.token,
        ),
      ).catch((err) => {
        if (axios.isCancel(err)) {
        } else {
          console.error(err);
        }
      });
    };

    useEffect(() => {
      return () => {
        if (cancelRef.current) cancelRef.current();
      };
    }, []);

    useEffect(() => {
      if (GetListApplicants?.rows && GetListApplicants?.rows?.length > 0) {
        setAlljobData(GetListApplicants.rows);
        setFindconfig({
          ...findconfig,
          totalRecords: GetListApplicants.total_count,
        }); // totalRecords: 0
        setTotalRecords(null);
        dispatch(
          _serapplicant.searchApplicantsWithPagingStartReducer(initalState),
        );
      } else if (GetListApplicants?.rows?.length === 0) {
        setAlljobData([]);
      }
    }, [GetListApplicants]);

    const handleChange = (event, Value) => {
      setAlljobData([]);
      setValue(Value);
      if (parseInt(Value) === 1) {
        setjobData(null);
        let limitObj = { limit: 50, offset: 1 };
        GetData(limitObj);
      }
    };

    const onReceivePropsHandler = (pannel, load) => {
      onReceivechildProps(pannel, load);
    };

    const onManualuploadHandler = () => {
      let json = {
        Applicants: {
          firstName: "",
          lastName: "",
          phone: "",
          emailId: "",
          alternateContactNumber: "",
          resumesourceId: sourceId,
        },
        totalExperience: null,
        linkedIn: "",
        educationDetails: [],
        workExp: [],
        skillDetails: [],
        certification: [],
        identifier: "",
        customFields: JSON.stringify([]),
        jobDescription: "",
        source: sourceId,
        id: 0,
      };
      navigate("/ats/layout/applicants/create", {
        state: {
          applicant: json,
          sourceId: sourceId,
          uploadfile: defaultFile,
          isAssociate: jobObj,
          isduplicate: false,
          isManual: true,
          associateAnyway: true,
          showLandingPage: false,
        },
      });
    };

    const onManualPopup = (isPopup, sourceId, file, obj) => {
      if (sourceId !== null && file !== null) {
        setManualApplicatsConfirmPopup(isPopup);
        setSourceId(sourceId);
        setDefaultFile(file);
        if (obj !== null) {
          setSkipId(obj.id);
          let json = {
            Applicants: obj.data.Applicants,
            totalExperience: obj.data.totalExperience
              ? obj.data.totalExperience
              : null,
            linkedIn: obj.data.linkedIn ? obj.data.linkedIn : "",
            educationDetails: obj.data.educationDetails
              ? obj.data.educationDetails
              : [],
            workExp: obj.data.workExperiences ? obj.data.workExperiences : [],
            skillDetails: obj.data.skillDetails ? obj.data.skillDetails : [],
            certification: obj.data.certifications
              ? obj.data.certifications
              : [],
            identifier: obj.data.identifier ? obj.data.identifier : "",
            jobDescription: "",
            customFields: JSON.stringify([]),
            source: sourceId,
            id: obj.id,
            oldApplicantName: obj.oldApplicantName ? obj.oldApplicantName : "",
            Resume: file,
          };
          setUpdateProfileWithNewResume(json);
          setDuplicateApplicatsConfirmPopup(true);
        }
      } else {
        setTwoDuplicateApplicatsConfirmPopup(true);
        setSkipId(obj.data.id);
        setSkipName(obj.data.name);
      }
    };

    useEffect(() => {
      if (JobId) {
        let subPathObj = JSON.parse(localStorage.getItem("subpathObj"));
        if (subPathObj && subPathObj.length > 0) {
          let index = subPathObj.findIndex((x) => x.id === JobId);
          let jobCode = "";
          if (index !== -1) {
            jobCode = subPathObj[index].name;
          }
          if (jobCode) {
            let matches = jobCode.match(/\(([^)]+)\)/g);
            let splitJobcode = matches[matches.length - 1].replace(/[()]/g, "");
            let jobCodeobj = { jobId: JobId, jobCode: splitJobcode };
            setJobObj(jobCodeobj);
          }
        }
      }
    }, [JobId]);

    useEffect(() => {
      // Guard: only navigate when skipId is set. UploadDocCode can be 200 from
      // a stale job-creation document upload (shared Redux state key), which
      // would otherwise navigate to /applicants/documents/null.
      if (UploadDocCode === 200 && skipId !== null) {
        navigate(`/ats/layout/applicants/documents/${skipId}`);
        dispatch(_serapplicant.uploadDocumentsStartReducer(initalState));
      } else if (UploadDocCode === 200 && skipId === null) {
        // Clear stale state without navigating
        dispatch(_serapplicant.uploadDocumentsStartReducer(initalState));
      }
    }, [UploadDocCode, skipId]);

    ///////////////////////////////////////////////////// FOR APPLICANT PROFILE VIEW /////////////////////////////////////////

    useEffect(() => {
      let defaultPostingModules = defaultApplicantsData.filter(
        (x) => x.moduleId === "2",
      );
      if (defaultPostingModules.length > 0) {
        defaultPostingModules.forEach((list) => {
          if (list.fieldName === "Candidate status") {
            setCandidateStatusValues(list.customValues);
          }
        });
      }
    }, []);

    const customFieldsData = useSelector((state) => state.CustomFields.data);

    useEffect(() => {
      async function init() {
        let userId = await GetUserId();
        dispatch(customFieldsAsync(userId));
      }
      init();
    }, []);

    useEffect(() => {
      if (customFieldsData && customFieldsData.length > 0) {
        const array = getCandidateStatusCustomValues(customFieldsData);
        setCandidateStatusValues(array);
      }
    }, [customFieldsData]);

    const handleChangeProfile = (event, Value) => {
      setProfileValue(Value);
    };

    useEffect(() => {
      if (profileData?.applicantId) {
        // setBreadCrumb(profileData.applicantId, profileData.applicantName, "Applicant Code");
        setUser(profileData?.notesData || []);
        let auditLogData = (profileData?.auditData || []).map((item) => {
          return {
            ...item,
            createdAt: item.createdAt
              ? GetTimeZone(item.createdAt)
              : item.createdAt,
          };
        });
        setAuditlogData(auditLogData);
      }
    }, [profileData]);

    const onChangeHandler = (value, type) => {
      let obj = JSON.parse(JSON.stringify(initialData));
      if (type == "noteText" && value.data.trim().length !== 0) {
        obj[type] = value.data;
        localStorage.setItem("ApplicantText", JSON.stringify(obj.noteText));
      } else if (type === "noteType") {
        setNoteType(value);
        obj.noteText = JSON.parse(localStorage.getItem("ApplicantText"));
      } else if (type === "candidateStatus") {
        setUpdateStatus(value);
      }
      setProfileUpdate(obj);
    };

    const HandleSubmit = async (event) => {
      if (updateStatus !== "") {
        let jobId = getJobCode;
        const statusId = getCandidateStatusId(
          updateStatus,
          candidateStatusValues,
        );
        let updateData = {
          data: [
            {
              id: profileData.assocId.toString(),
              status: statusId,
              applicantCode: profileData.applicantCode,
              applicantId: profileData.applicantId.toString(),
              jobCode: jobObj.jobCode,
            },
          ],
        };
        dispatch(_ser.updateCandidateStatusAsync(jobId, updateData));
      } else {
        dispatch(updateSnackbar({ type: "error", message: "Change status" }));
      }
    };

    const updateCandidateCode = useSelector(
      (state) => state.UpdateCandidateStatus.data,
    );

    useEffect(() => {
      if (updateCandidateCode === 200) {
        dispatch(_ser.updateCandidateStatusStartReducer(initalState));
        onReceivechildProps(false, "getFetch");
      }
    }, [updateCandidateCode]);

    const HandleSubmitNote = async (event) => {
      if (profileUpdate.noteText) {
        const userInfo = await getUserDetails();
        let obj = {
          notes: profileUpdate.noteText,
          noteType: noteType,
          moduleType: "applicants",
          moduleId: profileData.applicantId,
          userId: userInfo.userId,
          firstName: userInfo.firstName,
          lastName: userInfo.lastName,
        };
        dispatch(_serapplicant.addNotesAsync(obj));
        localStorage.removeItem("ApplicantText");
      } else {
        dispatch(
          updateSnackbar({ type: "error", message: "Please add notes" }),
        );
      }
    };

    const code = useSelector((state) => state.AddApplicantNotes.data);

    useEffect(() => {
      if (code === 200) {
        dispatch(_serapplicant.addNotesStartReducer(initalState));
        onReceivechildProps(false, "getFetch");
        setProfileUpdate("");
      }
    }, [code]);

    const storedTheme = JSON.parse(localStorage.getItem("themeSettings")) || "";

    return (
      <>
        {componentType === "AssociatedApplicants" && (
          <div className="tabs">
            <Box
              sx={{
                width: "100%",
                typography: "body1",
                color: "#3B4046",
                marginTop: "-35px",
              }}
            >
              <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <TabList
                    onChange={handleChange}
                    aria-label="lab API tabs example"
                    className="tabsvalue"
                  >
                    <Tab label="Add new applicant" value="3" />
                    <Tab label="AI matched applicants" value="1" />
                    <Tab label="Find applicants" value="2" />
                  </TabList>
                </Box>
                <TabPanel value="1">
                  <div>
                    {showLoader.value && !showLoader.isGlobalLoading ? (
                      <Loader />
                    ) : (
                      ""
                    )}
                    {jobData && jobData.length > 0 ? (
                      <AssociateCards
                        data={jobData}
                        showSearchBar={false}
                        selectedItems={selectedIds}
                        isAImatched={true}
                        searchKeyWord="Search by Applicant code, Name"
                        navigateTo="/ats/layout/applicants/view/"
                        config={aiconfig}
                        componentType="AssociatedApplicants"
                        onReceiveHandler={(Item, obj) =>
                          onActionHandler(Item, obj)
                        }
                      />
                    ) : (
                      !(showLoader.value && !showLoader.isGlobalLoading) && (
                        <div>
                          <div className="nodatasection nodataSection">
                            <img
                              src={
                                process.env.PUBLIC_URL + "/assests/nodata.svg"
                              }
                              alt="noResult"
                            />
                            No AI match applicants
                          </div>
                        </div>
                      )
                    )}
                  </div>
                </TabPanel>
                <TabPanel value="2">
                  <div className="mt-5">
                    {showLoader.value && !showLoader.isGlobalLoading ? (
                      <Loader />
                    ) : (
                      ""
                    )}
                    {AlljobData ? (
                      <AssociateCards
                        data={AlljobData}
                        selectedItems={selectedIds}
                        isAImatched={false}
                        searchKeyWord="Search by Applicant code, Name"
                        navigateTo="/ats/layout/applicants/view/"
                        config={findconfig}
                        componentType="AssociatedApplicants"
                        onReceiveHandler={(Item, obj) =>
                          onActionHandler(Item, obj)
                        }
                      />
                    ) : (
                      <div>
                        <div className="nodatasection nodataSection">
                          <img
                            src={process.env.PUBLIC_URL + "/assests/nodata.svg"}
                            alt="noResult"
                          />
                          No Find Applicants
                        </div>
                      </div>
                    )}
                  </div>
                </TabPanel>
                <TabPanel value="3">
                  {/* className="pannelContent" */}
                  <div>
                    <ApplicantsRenderData
                      onReceivechildProps={onReceivePropsHandler}
                      onManualPopup={onManualPopup}
                      isAssociate={jobObj}
                    />
                  </div>
                </TabPanel>
              </TabContext>
            </Box>
          </div>
        )}
        {/* ///////////////////////// FOR APPLICANT PROFILE VIEW //////////////////// */}
        {componentType === "ApplicantProfile" && (
          <div className="tabs">
            <Box
              sx={{
                width: "100%",
                typography: "body1",
                color: "#3B4046",
                marginTop: "-35px",
              }}
            >
              <TabContext value={profileValue}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <TabList
                    onChange={handleChangeProfile}
                    aria-label="lab API tabs example"
                    className="tabsvalue"
                  >
                    <Tab label="Details" value="1" />
                    <Tab label="Notes" value="2" />
                    <Tab label="Audit Information" value="3" />
                  </TabList>
                </Box>
                <TabPanel value="1">
                  <div className="jobsdataView">
                    <div>
                      <tr>
                        <td>Applicant Name</td>
                        <td>:</td>
                        <td>{profileData.applicantName}</td>
                      </tr>
                      <tr>
                        <td>Contact Number</td>
                        <td>:</td>
                        <td>
                          {profileData.contactNumber}
                          {profileData.alternateContactNumber
                            ? ` / ${profileData.alternateContactNumber}`
                            : ""}
                        </td>
                      </tr>
                      <tr>
                        <td>E-mail</td>
                        <td>:</td>
                        <td>{profileData.email}</td>
                      </tr>
                      <tr>
                        <td>Status</td>
                        <td>:</td>
                        <td>{profileData.status}</td>
                      </tr>
                    </div>
                    {profileData?.filePath && (
                      <div>
                        <div className="pdfView">
                          {profileData.filePath.includes(".pdf") ? (
                            <img
                              src={
                                process.env.PUBLIC_URL + "/assests/img/pdf.svg"
                              }
                              alt=""
                              className="pdficonView"
                            />
                          ) : (
                            <img
                              src={
                                process.env.PUBLIC_URL + "/assests/img/docx.svg"
                              }
                              alt=""
                              className="pdficonView"
                            />
                          )}

                          <div className="iconsView">
                            <Button
                              variant="icon"
                              className="iconView"
                              onClick={() =>
                                onReceivePropsHandler(profileData, "view")
                              }
                            >
                              <ViewFileIcon />
                            </Button>

                            <Button
                              variant="icon"
                              className="documentdownloadiconView"
                              onClick={() =>
                                onReceivePropsHandler(profileData, "download")
                              }
                            >
                              <DownloadIcon />
                            </Button>
                          </div>
                        </div>

                        {(profileData.uploadedBy || profileData.uploadedOn) && (
                          <div style={{ fontSize: "11px" }}>
                            {profileData.uploadedBy && (
                              <p style={{ margin: "0px", color: "#262626" }}>
                                {" "}
                                <strong
                                  style={{
                                    margin: "0px",
                                    color: "#262626",
                                    fontWeight: "500",
                                  }}
                                >
                                  Uploaded by{" "}
                                </strong>{" "}
                                : {profileData.uploadedBy}
                              </p>
                            )}
                            {profileData.uploadedOn && (
                              <p style={{ margin: "0px", color: "#262626" }}>
                                {" "}
                                <strong
                                  style={{
                                    margin: "0px",
                                    color: "#262626",
                                    fontWeight: "500",
                                  }}
                                >
                                  Uploaded on{" "}
                                </strong>
                                : {GetTimeZone(profileData.uploadedOn)}
                              </p>
                            )}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  <Divider className="secline" />

                  <div className="statusdropdwnView">
                    <p>Update Status</p>
                    <div style={{ width: "25%" }}>
                      <FormControl fullWidth>
                        <Select
                          className="sourcedfrominput"
                          value={
                            updateStatus !== ""
                              ? updateStatus
                              : profileData.status
                          }
                          name="candidateStatus"
                          autoComplete="off"
                          onChange={(e) =>
                            onChangeHandler(e.target.value, "candidateStatus")
                          }
                          style={{
                            width: "85%",
                            height: "2rem",
                            borderRadius: "4px",
                          }}
                          displayEmpty
                          renderValue={(profileData) => {
                            if (
                              updateStatus === ""
                                ? profileData === "undefined"
                                : false
                            ) {
                              return <span color="gray">Select</span>;
                            } else {
                              return updateStatus === ""
                                ? profileData
                                : updateStatus;
                            }
                          }}
                        >
                          {candidateStatusValues.map((status) => (
                            <MenuItem
                              className="selectOptions"
                              key={status.id}
                              value={status.internal}
                            >
                              {status.internal}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                    <div className="updatebuttonView">
                      <Button
                        className="savebtn"
                        variant="contained"
                        size="medium"
                        type="submit"
                        onClick={HandleSubmit}
                      >
                        Update
                      </Button>
                    </div>
                  </div>

                  <Divider className="secline" />
                  <div className="typeCss">
                    <span>Note Type</span>
                    <FormControl>
                      <Select
                        className="noteTypeselect"
                        label="Select Type"
                        value={noteType}
                        autoComplete="off"
                        onChange={(e) =>
                          onChangeHandler(e.target.value, "noteType")
                        }
                      >
                        <MenuItem className="selectOptions" value={"Call"}>
                          Call
                        </MenuItem>
                        <MenuItem className="selectOptions" value={"E-mail"}>
                          E-mail
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>

                  <div id="jobDescForSMnew">
                    <CkEditor
                      data={profileUpdate.noteText}
                      initRawData={initialData.noteText}
                      autoComplete="off"
                      name="note"
                      isReadonly={false}
                      onUpdatehandler={(update) =>
                        onChangeHandler(update, "noteText")
                      }
                    />
                  </div>

                  <div className="updatebutton1">
                    <Button
                      className="savebtn"
                      variant="contained"
                      size="medium"
                      type="submit"
                      onClick={HandleSubmitNote}
                    >
                      Update
                    </Button>
                  </div>
                </TabPanel>
                <TabPanel value="2">
                  <div>
                    {user.length > 0 ? (
                      <>
                        {user.map((elem, i) => {
                          return (
                            <>
                              <div
                                className="Applicantprofilearticle"
                                style={{ position: "relative" }}
                              >
                                <div className="usericon">
                                  {elem.noteType === "Call" ? (
                                    <Notescall
                                      secondaryColor={
                                        storedTheme?.secondaryColor
                                      }
                                      secondaryFontColor={
                                        storedTheme?.secondaryFontColor
                                      }
                                      width={40}
                                      height={40}
                                    />
                                  ) : (
                                    <Notesemail
                                      secondaryColor={
                                        storedTheme?.secondaryColor
                                      }
                                      secondaryFontColor={
                                        storedTheme?.secondaryFontColor
                                      }
                                      width={40}
                                      height={40}
                                    />
                                  )}
                                </div>
                                <div className="jobnote">
                                  <b>{elem.firstName + " " + elem.lastName}</b>
                                  <div
                                    style={{ maxWidth: "calc(100% - 150px)" }}
                                    dangerouslySetInnerHTML={{
                                      __html: elem.notes,
                                    }}
                                  ></div>
                                  <span className="createdDate">
                                    {GetTimeZone(elem.createdAt)}
                                  </span>
                                </div>
                              </div>
                              <Divider className="secline" />
                            </>
                          );
                        })}
                      </>
                    ) : (
                      <h1
                        style={{
                          fontWeight: 300,
                          lineHeight: 1.2,
                          textAlign: "center",
                          margin: "60px 0",
                          fontSize: "3rem",
                        }}
                      >
                        No notes found
                      </h1>
                    )}
                  </div>
                </TabPanel>
                <TabPanel value="3">
                  <div>
                    {AuditlogData.length > 0 ? (
                      AuditlogData.map((e) => (
                        <div className="jobsdatacss">
                          {/* <div className="jobsdata1"> */}
                          <tr>
                            <td>Name</td>
                            <td>:</td>
                            <td>{e.fullName}</td>
                          </tr>
                          <tr>
                            <td>Action Performed</td>
                            <td>:</td>
                            <td>{e.action}</td>
                          </tr>
                          <tr>
                            <td>Date and Time</td>
                            <td>:</td>
                            <td>{e.createdAt}</td>
                          </tr>
                          <tr>
                            <td>Comments</td>
                            <td>:</td>
                            <td>{e.comments}</td>
                          </tr>
                          {/* </div> */}
                          <Divider className="secline" />
                        </div>
                      ))
                    ) : (
                      <h1
                        style={{
                          fontWeight: 300,
                          lineHeight: 1.2,
                          textAlign: "center",
                          margin: "60px 0",
                          fontSize: "3rem",
                        }}
                      >
                        No auditlog found
                      </h1>
                    )}
                  </div>
                </TabPanel>
              </TabContext>
            </Box>
          </div>
        )}
        {/* ///////////////////////// FOR APPLICANT PROFILE VIEW END/////////////////////// */}
        {componentType === "Questions&Answers" && (
          <div style={{ padding: "20px" }}>
            {questionsData.length > 0 &&
              questionsData.map((item, index) => {
                return (
                  <div
                    className="questionsarea"
                    key={index}
                    style={{
                      marginBottom: "24px",
                      border: "none",
                      marginTop: "10px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        gap: "8px",
                        marginBottom: "12px",
                        textAlign: "left",
                        wordBreak: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      <h4
                        style={{
                          fontSize: "18px",
                          fontWeight: 600,
                          color: "#333",
                          margin: 0,
                          flexShrink: 0,
                        }}
                      >
                        {`${index + 1})`}
                      </h4>
                      <h4
                        style={{
                          fontSize: "18px",
                          fontWeight: 600,
                          color: "#333",
                          margin: 0,
                        }}
                      >
                        {item.question}
                      </h4>
                    </div>
                    <div
                      style={{
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        padding: "12px",
                        minHeight: "100px",
                        backgroundColor: "#fff",
                        color: "#000",
                        wordWrap: "break-word",
                        wordBreak: "break-word",
                        whiteSpace: "pre-wrap",
                        textAlign: "left",
                      }}
                    >
                      {item.answer.join(", ")}
                    </div>
                  </div>
                );
              })}
          </div>
        )}

        {/* Manual Upload popup */}
        {manualApplicatsConfirmPopup === true && (
          <section className="customModal">
            <div className="customModalDiv">
              <h1 className="modal-header">Error</h1>
              <div className="modal-body">
                <p>
                  We are currently facing a technical glitch. Please select to
                  upload resume manually.
                </p>
                <div className="modalActionBtns">
                  <Button
                    type="button"
                    className="cancelBtn"
                    style={{ marginRight: "20px" }}
                    onClick={() => {
                      setManualApplicatsConfirmPopup(false);
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="button"
                    variant="contained"
                    className="saveBtn"
                    onClick={onManualuploadHandler}
                  >
                    Upload Manually
                  </Button>
                </div>
              </div>
            </div>
          </section>
        )}
        {duplicateApplicatsConfirmPopup === true && (
          <ApplicantsManualUploadPopup
            skipId={skipId}
            jobId={jobObj.jobId}
            isAssociatedApplicant={true}
            updateProfileWithNewResume={updateProfileWithNewResume}
            sourceId={sourceId}
            defaultFile={defaultFile}
            setDuplicateApplicatsConfirmPopup={(e) => {
              setDuplicateApplicatsConfirmPopup(e);
              // setSkipId(null);
            }}
          />
        )}
        {twoDuplicateApplicatsConfirmPopup === true && (
          <DuplicateApplicantsManualUploadPopup
            skipId={skipId}
            skipName={skipName}
            setTwoDuplicateApplicatsConfirmPopup={() => {
              setTwoDuplicateApplicatsConfirmPopup(false);
              dispatch(_ser1.uploadResumeStartReducer(initalState));
              // setSkipId(null);
              setSkipName(null);
            }}
          />
        )}
      </>
    );
  },
);

const BulkComponentRenderData = ({ data, onReceivechildProps }) => {
  return (
    <>
      <div className="tabs">
        <TabContext value={"1"}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList
              onChange={""}
              aria-label="lab API tabs example"
              className="tabsvalue"
            >
              <Tab label="Bulk upload Results" value="1" />
            </TabList>
          </Box>
          <TabPanel value="1">
            {data && (
              <div>
                <div className="jobsdatacss">
                  <tr>
                    <td>Total Resumes</td>
                    <td>:</td>
                    <td>{data.totalResume}</td>
                  </tr>
                  {/* <tr>
                          <td>Successful</td>
                          <td>:</td>
                          <td>{data.successful}</td>
                        </tr>
                       <tr>
                          <td>Failed</td>
                          <td>:</td>
                          <td>{data.failed}</td>
                        </tr> */}
                </div>
                <br />
                <Divider className="secline" />
                <p>
                  Your documents have been submitted for offline processing.
                  Once the process is complete, you will receive a confirmation
                  email and Please refresh the page.
                </p>
                {data.data &&
                  data.data.map((msg) => {
                    return (
                      <ul>
                        <li
                          style={{ textAlign: "left" }}
                          dangerouslySetInnerHTML={{ __html: msg }}
                        ></li>
                      </ul>
                    );
                  })}
              </div>
            )}
          </TabPanel>
        </TabContext>
      </div>
    </>
  );
};

const BulkUpdateStatus = ({
  data,
  bulkUpdateStatusArray,
  onReceivechildProps,
}) => {
  const [bulkUpdateStatus, setBulkUpdateStatus] = useState("");

  const onChangeHandler = (value) => {
    setBulkUpdateStatus(value);
  };

  const getJobCode = GetJobId();
  const dispatch = useDispatch();

  const handlebulkstatusUpdate = () => {
    if (bulkUpdateStatus !== "") {
      const url = window.location.pathname;
      const path = url.substring(url.lastIndexOf("/") + 1);
      let jobCode = "";
      if (Number.isInteger(parseInt(path))) {
        let subpathObj = JSON.parse(localStorage.getItem("subpathObj"));
        if (subpathObj && subpathObj.length > 0) {
          let filterSubObj = subpathObj.filter(
            (x) => x.id === parseInt(path) && x.type === "Job Code",
          );
          if (filterSubObj.length > 0) {
            jobCode = filterSubObj[0].name;
          }
        }
      }
      let matches = jobCode.match(/\(([^)]+)\)/g);
      let splitJobcode = matches[matches.length - 1].replace(/[()]/g, "");
      const statusId = getCandidateStatusId(bulkUpdateStatus, data);

      let newArray = bulkUpdateStatusArray.map((obj) => ({
        id: obj.asscoId,
        status: statusId,
        applicantCode: obj.applicantCode,
        applicantId: obj.applicantID.toString(),
        jobCode: splitJobcode,
      }));
      let updateData = { data: newArray };

      dispatch(_ser.updateCandidateStatusAsync(getJobCode, updateData));
    } else {
      dispatch(updateSnackbar({ type: "error", message: "Change status" }));
    }
  };

  const updateCandidateCode = useSelector(
    (state) => state.UpdateCandidateStatus.data,
  );
  useEffect(() => {
    if (updateCandidateCode === 200) {
      dispatch(_ser.updateCandidateStatusStartReducer(initalState));
      onReceivechildProps(false, "close");
    }
  }, [updateCandidateCode]);

  return (
    <>
      <div className="tabs">
        <TabContext value={"1"}>
          <Box>
            <TabList
              onChange={""}
              aria-label="lab API tabs example"
              className="tabsvalue"
            >
              <Tab label="Details" value="1" />
            </TabList>
          </Box>
          <TabPanel value="1">
            {data && (
              <div className="bulkupdateStatusText">
                <tr>
                  <td>No of Applicants Selected</td>
                  <td>:</td>
                  <td>{bulkUpdateStatusArray.length}</td>
                </tr>

                <br />
                <tr>
                  <td>Update Status for Selected Applicants</td>
                  <td>
                    <div style={{ width: "100%" }}>
                      <FormControl fullWidth>
                        {/* <InputLabel className="boldSelectlabel">Candidate's Status</InputLabel> */}
                        <Select
                          className="sourcedfrominput"
                          value={bulkUpdateStatus}
                          name="candidateStatus"
                          autoComplete="off"
                          // label="Candidate's Status&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"
                          // disabled={updateStatus ? false : true}
                          onChange={(e) =>
                            onChangeHandler(e.target.value, "candidateStatus")
                          }
                          style={{
                            width: "200px",
                            height: "2rem",
                            borderRadius: "4px",
                          }}
                          // onFocus={formik.handleBlur}
                          displayEmpty
                          renderValue={(profileData) => {
                            if (bulkUpdateStatus === "") {
                              return (
                                <span
                                  color="gray"
                                  className="bulkstatusselectfeild"
                                >
                                  Select
                                </span>
                              );
                            } else {
                              return bulkUpdateStatus;
                            }
                          }}
                        >
                          {data.map((status) => (
                            <MenuItem
                              className="selectOptions"
                              key={status.id}
                              value={status.internal}
                            >
                              {status.internal}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </td>
                </tr>
              </div>
            )}
          </TabPanel>
        </TabContext>

        <div className="bulkUploadStatusUpdateButton">
          <Button
            className="updateButton"
            variant="contained"
            size="medium"
            type="submit"
            // disabled={updateStatus ? false : true}
            onClick={handlebulkstatusUpdate}
          >
            Update
          </Button>
        </div>
      </div>
    </>
  );
};

const ViewDocument = (props) => {
  const [docUrl, setDocUrl] = useState(null);

  useEffect(() => {
    if (props.previewType !== "") {
      setDocUrl(props.previewType);
    }
  }, [props]);

  // const downloadHandler = () => {
  //   props.onReceivechildProps({filePath:props.data.filePath}, "download");
  // }

  return (
    <>
      <div
        style={{ textAlign: "center", width: "100%" }}
        className="associationDocViewer"
      >
        {docUrl !== null ? (
          <>
            {/* <DocumentViewer
              url={docUrl}
              // viewerUrl={docUrl}
              style={{ width: "100%", height: "calc(100vh - 120px)" }}
            >
            </DocumentViewer> */}
            <DocumentViewer
              url={docUrl}
              fileType={getFileExtension(docUrl)}
              // onDownload={() => handleDownload(docUrl)}
              // onDownload={() => {
              //     props.onReceivechildProps(
              //         { path: docPath, fileType: docUrl.split('.').pop().split('?')[0] },
              //         "",
              //         "download"
              //     );
              // }}
            />
            {/* <div className="floatBtn" onClick={downloadHandler}>
              <FloatButon />
            </div> */}
          </>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default JobpostingsAssociatedApplicantsProfile;

const aiconfiguration = {
  recordperPage: 9,
  currentPage: 1,
  totalRecords: 0,
  limitData: 9,
  isSearchServer: false,
};

const findconfiguration = {
  recordperPage: 9,
  currentPage: 1,
  totalRecords: 0,
  limitData: 9,
  isSearchServer: true,
};

const configuration = {
  isSearchbar: true,
  isPaging: true,
  isDropdownActions: true,
  isCheckbox: true,
  isActions: true,
  recordperPage: 10,
  currentPage: 1,
  totalRecords: 0,
  isTotalCount: false,
  totalRecordsCount: 0,
  totalRecordsCountText: "",
  limitData: 10,
  isCheckAlignRight: true,
  isPaginationTop: false,
  isSearchServer: false,
  isPagingServer: false,
  isPageRange: true,
};

// for dynamic Table Action dropdownData
const actionsDropdownData = ["Delete", "Send E-mail", "Update Status"];
const actionsDropdownDataPending = ["Accept", "Reject"];

// for dynamic Table row Action buttons
const actionsList = {
  isPostingsDownload: true,
  isPositingsView: true,
  isDelete: false,
};

// for dynamic Table Headers and columns
const columnsData = [
  {
    id: 1,
    displayName: "Applicant ID",
    mappingName: "applicantCode",
    theadClass: "text-center dynatableheadtext",
    tbodyClass: "text-center dynatablebodytext textUnderline",
    width: "90px",
    isEdit: true,
    nagigate: "detailspage",
  },
  {
    id: 2,
    displayName: "Applicant Name",
    mappingName: "Applicantname",
    theadClass: "text-center  dynatableheadtext",
    tbodyClass: "text-center dynatablebodytext NameCapitalise",
    width: "180px",
    isEdit: true,
    nagigate: "detailspage",
  },
  {
    id: 3,
    displayName: "Contact Number",
    mappingName: "ContactNumber",
    theadClass: "text-center  dynatableheadtext",
    tbodyClass: "text-center dynatablebodytext",
    width: "120px",
    isEdit: true,
    nagigate: "detailspage",
  },
  {
    id: 4,
    displayName: "Last Updated",
    mappingName: "updatedDate",
    theadClass: "text-center  dynatableheadtext",
    tbodyClass: "text-center dynatablebodytext",
    width: "130px",
    isEdit: true,
    nagigate: "detailspage",
  },
  {
    id: 5,
    displayName: "Recruiter Name",
    mappingName: "submittedByUser",
    theadClass: "text-center  dynatableheadtext",
    tbodyClass: "text-center dynatablebodytext",
    width: "130px",
    isEdit: true,
    nagigate: "detailspage",
  },
  {
    id: 6,
    displayName: "Sourced From",
    mappingName: "SourcedFrom",
    theadClass: "text-center text-center dynatableheadtext",
    tbodyClass: "text-center dynatablebodytext",
    width: "120px",
    isEdit: true,
    nagigate: "detailspage",
  },
  {
    id: 7,
    displayName: "Candidate Status",
    mappingName: "status",
    theadClass: "text-center text-center dynatableheadtext",
    tbodyClass: "text-center dynatablebodytext",
    width: "120px",
    isEdit: true,
    nagigate: "detailspage",
  },
  {
    id: 8,
    displayName: "Percentage",
    mappingName: "percentage",
    theadClass: "text-center text-center dynatableheadtext",
    tbodyClass: "text-center dynatablebodytext",
    width: "200px",
    isEdit: false,
    nagigate: "detailspage",
  },
];

const portalsColumnsData = [
  {
    id: 1,
    displayName: "Applicant ID",
    mappingName: "applicantCode",
    theadClass: "text-center dynatableheadtext",
    tbodyClass: "text-center dynatablebodytext textUnderline",
    width: "90px",
    isEdit: true,
    nagigate: "detailspage",
  },
  {
    id: 2,
    displayName: "Applicant Name",
    mappingName: "Applicantname",
    theadClass: "text-center  dynatableheadtext",
    tbodyClass: "text-center dynatablebodytext NameCapitalise",
    width: "210px",
    isEdit: true,
    nagigate: "detailspage",
  },
  {
    id: 3,
    displayName: "Contact Number",
    mappingName: "ContactNumber",
    theadClass: "text-center  dynatableheadtext",
    tbodyClass: "text-center dynatablebodytext",
    width: "",
    isEdit: true,
    nagigate: "detailspage",
  },
  {
    id: 4,
    displayName: "Last Updated",
    mappingName: "updatedDate",
    theadClass: "text-center text-center dynatableheadtext",
    tbodyClass: "text-center dynatablebodytext",
    width: "",
    isEdit: true,
    nagigate: "detailspage",
  },
  {
    id: 5,
    displayName: "Sourced By",
    mappingName: "submittedByUser", //createdBy
    theadClass: "text-center  dynatableheadtext",
    tbodyClass: "text-center dynatablebodytext",
    width: "",
    isEdit: true,
    nagigate: "detailspage",
  },
  {
    id: 6,
    displayName: "Sourced From",
    mappingName: "SourcedFrom",
    theadClass: "text-center text-center dynatableheadtext",
    tbodyClass: "text-center dynatablebodytext",
    width: "",
    isEdit: true,
    nagigate: "detailspage",
  },
  {
    id: 7,
    displayName: "Screening Questions",
    mappingName: "screeningquestions",
    theadClass: "text-center text-center dynatableheadtext",
    tbodyClass: "text-center dynatablebodytext td-flex",
    width: "",
    isEdit: false,
    nagigate: null,
  },
];
const rejectColumnsData = [
  {
    id: 1,
    displayName: "Applicant ID",
    mappingName: "applicantCode",
    theadClass: "text-center dynatableheadtext",
    tbodyClass: "text-center dynatablebodytext textUnderline",
    width: "90px",
    isEdit: true,
    nagigate: "detailspage",
  },
  {
    id: 2,
    displayName: "Applicant Name",
    mappingName: "Applicantname",
    theadClass: "text-center  dynatableheadtext",
    tbodyClass: "text-center dynatablebodytext NameCapitalise",
    width: "210px",
    isEdit: true,
    nagigate: "detailspage",
  },
  {
    id: 3,
    displayName: "Contact Number",
    mappingName: "ContactNumber",
    theadClass: "text-center  dynatableheadtext",
    tbodyClass: "text-center dynatablebodytext",
    width: "",
    isEdit: true,
    nagigate: "detailspage",
  },
  {
    id: 4,
    displayName: "Last Updated",
    mappingName: "updatedDate",
    theadClass: "text-center text-center dynatableheadtext",
    tbodyClass: "text-center dynatablebodytext",
    width: "",
    isEdit: true,
    nagigate: "detailspage",
  },
  {
    id: 5,
    displayName: "Sourced By",
    mappingName: "submittedByUser", //createdBy
    theadClass: "text-center  dynatableheadtext",
    tbodyClass: "text-center dynatablebodytext",
    width: "",
    isEdit: true,
    nagigate: "detailspage",
  },
  {
    id: 6,
    displayName: "Sourced From",
    mappingName: "SourcedFrom",
    theadClass: "text-center text-center dynatableheadtext",
    tbodyClass: "text-center dynatablebodytext",
    width: "",
    isEdit: true,
    nagigate: "detailspage",
  },
  {
    id: 7,
    displayName: "Screening Questions",
    mappingName: "screeningquestions",
    theadClass: "text-center text-center dynatableheadtext",
    tbodyClass: "text-center dynatablebodytext td-flex",
    width: "",
    isEdit: false,
    nagigate: null,
  },
];

const ASAObj = {
  title: "Associated Applicants",
  description: "",
  bgImage: "",
};

const QAObj = {
  title: "Questions and Answers",
  description: "",
  bgImage: "",
};

const bulkResponseObj = {
  title: "Bulk Upload",
  description: "",
  bgImage: ``,
};
const UpdateStatusObj = {
  title: "Update Status",
  description: "",
  bgImage: "",
};
const docViewObj = {
  title: "Document view",
  description: "",
  bgImage: "",
};

const addNewModel = {
  url: "",
  displayName: "",
};

const initialData = {
  noteType: "",
  noteText: "",
};

const MailOBJ = {
  title: "Send E-mail",
  description: "",
  bgImage: `${process.env.PUBLIC_URL}/assests/img/emailbackground.svg`,
};
